/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeSquareIcon64Regular = forwardRef('ShapeSquareIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 17.5C7 11.701 11.701 7 17.5 7h29C52.299 7 57 11.701 57 17.5v29C57 52.299 52.299 57 46.5 57h-29C11.701 57 7 52.299 7 46.5v-29ZM17.5 10a7.5 7.5 0 0 0-7.5 7.5v29a7.5 7.5 0 0 0 7.5 7.5h29a7.5 7.5 0 0 0 7.5-7.5v-29a7.5 7.5 0 0 0-7.5-7.5h-29Z" })));
});
